import React from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CButton,
  CBadge,
  CAvatar
} from '@coreui/react'
import { CIcon } from '@coreui/icons-react'
import { cilEnvelopeOpen, cilPlus, cilUser } from '@coreui/icons'

const Messages = () => {
  return (
    <>
      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader className="d-flex justify-content-between align-items-center">
              <div>
                <strong>Messages</strong>
                <small className="text-muted ms-2">Communication center</small>
              </div>
              <CButton color="primary" size="sm">
                <CIcon icon={cilPlus} className="me-2" />
                New Message
              </CButton>
            </CCardHeader>
            <CCardBody>
              <div className="text-center py-5">
                <CIcon 
                  icon={cilEnvelopeOpen} 
                  size="3xl" 
                  className="text-muted mb-3"
                />
                <h5 className="text-muted">No messages yet</h5>
                <p className="text-muted">
                  Your messages and communications will appear here.
                </p>
                <CButton color="primary" variant="outline">
                  <CIcon icon={cilPlus} className="me-2" />
                  Send your first message
                </CButton>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

export default Messages 